import { Component, Inject, OnDestroy } from '@angular/core'
import { ImportantMessage } from '../state/important-message.model'
import { Subscription } from 'rxjs'
import { Store } from '@ngrx/store'
import { selectMessages } from '../state/main-view.selectors'

@Component({
    selector: 'ca-important-message',
    templateUrl: './important-message.html'
})
export class ImportantMessageComponent implements OnDestroy {

    messages: Array<ImportantMessage> = []

    #selectMessages: Subscription

    constructor(@Inject(Store) private store: Store,) {
        this.#selectMessages = this.store.select(selectMessages).subscribe(data => {
            this.messages = data
        })
    }

    ngOnDestroy(): void {
        this.#selectMessages?.unsubscribe()
    }

}